import { ComponentProps } from "react";
import { cn } from "@/zapi-frontend/shared/lib/utils";

const STATUS_STYLES = {
  complete: { container: "text-innoveraGreen-900", dot: "bg-innoveraGreen-600" },
  generating: { container: "text-innoveraOrange-400", dot: "bg-innoveraOrange-400" },
  framing: { container: "text-innoveraYellow-500", dot: "bg-innoveraYellow-400" }
} as const;

export type TStatusDotProps = ComponentProps<"span"> & {
  status: keyof typeof STATUS_STYLES;
};

export function StatusDot({ status, className, children, ...props }: TStatusDotProps) {
  const { container, dot } = STATUS_STYLES[status];
  return (
    <span className={cn("inline-flex items-center gap-1.5 text-[14px]", container, className)} {...props}>
      <span className={cn("h-1.5 w-1.5 shrink-0 rounded-full", dot)} />
      {children}
    </span>
  );
}
